<template>
    <div>
        <div class="contrainer">
            <div class="box-content">
                <div class="dc-tab-row">
                    <div
                        class="dc-tab"
                        :class="[{ active: activeTab == 'detail' }]"
                        @click="clickChangeTab('detail')"
                    >
                        <div v-if="!isSubscription" class="dc-inner-btn">
                            รายละเอียด
                        </div>
                        <div v-else class="dc-inner-btn">
                            รายละเอียดแพ็คเก็จ
                        </div>
                    </div>
                    <div
                        v-if="!hideCondition"
                        class="dc-tab"
                        :class="[{ active: activeTab == 'condition' }]"
                        @click="clickChangeTab('condition')"
                    >
                        <div class="dc-inner-btn">เงื่อนไข</div>
                    </div>
                </div>
                <div class="col-12 border-section"></div>
                <div class="col-12 box-detail-condition">
                    <!-- eslint-disable vue/no-v-html -->
                    <div
                        v-show="activeTab === 'detail'"
                        class="text-content"
                        v-html="detail"
                    ></div>
                    <div
                        v-show="activeTab === 'condition'"
                        class="text-content"
                        v-html="condition"
                    ></div>
                    <!--eslint-enable-->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";

/**
 * @event clickChangeTab
 */
export default {
    name: "CampaignDetailAndCondtition",
    props: {
        lbl: Object,
        campaign: Object,
        isSubscription: Boolean,
        hideCondition: Boolean,
    },
    data: function () {
        return {
            activeTab: "detail", //detail, condition
            detail: "",
            condition: "",
        };
    },
    created: function () {
        this.detail = Util.newLineToBrWithEscape(this.campaign.detail);
        this.condition = Util.newLineToBrWithEscape(this.campaign.condition);
    },
    methods: {
        //event
        clickChangeTab: function (tab) {
            this.activeTab = tab;
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/style/base/baseDisplay.scss";
@import "@/style/_mixin.scss";
.dc-tab-row {
    @extend %display-flex;
    .dc-tab {
        margin-right: 10px;
        color: $color-text;
        font-size: 16px;
        padding: 5px 10px;
        &.active {
            color: $color-text;
            background: #fff;
            border-radius: 20px;
            padding: 5px 10px;
            font-size: 16px;
        }
    }
}

.dc-content {
    width: 100%;
    padding: 25px 15px 40px;

    .dc-content-item {
        font-size: 1.1rem;
        word-break: break-word;
        line-height: 1.5;

        a {
            color: #d31145;
        }
    }
}

.box-content {
    margin-top: 10px;
    .border-section {
        border-top: 2px solid $color-light-grey-600;
        margin: 10px 0;
    }
    .box-detail-condition {
        overflow: auto;
        max-height: 35vh;
        padding: 0 0 55px 0;
        .text-content {
            color: $color-text;
            font-size: 14px;
            font-family: "PromptLight";
            line-height: normal;
            white-space: pre-wrap;
            margin-right: 5px;
        }
    }
}
</style>
